import { usePost } from '../usePost';

const API_URL = import.meta.env.VITE_API_URL;

export function useSalvarUsuario() {
  return usePost({
    url: `${API_URL}/usuarios/salvar`,
    config: {
      timeout: 120000,
      getAccessToken: true,
    },
  });
}
